<template>
	<div :class="$style['map-section']">
		<div ref="m" :class="$style['map']"></div>
		<PageIntroSection :small-title="$t('contact_title')">
			<template slot="left">
				<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_MEDIUM"
				                 :text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT" :scroll-animation-delay=".25">{{ $t('nav_contacts') }}
				</rr-animate-text>
				<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_MEDIUM"
				                 :text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT" :scroll-animation-delay=".35">2727 Mill Ave,
					Brooklyn, New York, 11234<br>iaroslav@motiondesign.school
				</rr-animate-text>
				<AnimateSocialLinks :class="$style['sl-wrap']" :scroll-animation-delay=".45"/>
			</template>
		</PageIntroSection>
		<rr-section :background-color="$const.HTML_CLASS.BACKGROUND_COLOR.TRANSPARENT">
			<container-inner>
				<row>
					<column :width="2">
						<AnimateContactForm/>
					</column>
				</row>
			</container-inner>
		</rr-section>
	</div>
</template>

<script>
import PageIntroSection from '../components/page/PageIntroSection'
// import SocialLinks from '../components/SocialLinks'
// import ContactForm from '../components/ContactForm'
import appearAfterLoadingAnimation from '../mixins/animations/appear-after-loading'
import AnimateContactForm from '../components/AnimateContactForm'
import AnimateSocialLinks from '../components/AnimateSocialLinks'
import {TimelineLite} from 'gsap/TimelineLite'

export default {
	name: 'works',
	components: {
		AnimateSocialLinks,
		AnimateContactForm,
		// ContactForm,
		// SocialLinks,
		PageIntroSection,
	},
	mixins: [appearAfterLoadingAnimation],
	metaInfo() {
		return {
			title: this.$t('nav_contacts')
		}
	},
	methods: {
		// appear timeline
		buildAppearTl() {
			this.appearTl = new TimelineLite({paused: 1})

			this.generateAppearTl(this.appearTl)

			this.appearTl.fromTo(this.$refs['m'], 1, {
				autoAlpha: 0,
			}, {
				autoAlpha: 1,
				ease: 'ease'
			}, '-=.55')
		},
	}
}
</script>

<style module lang="scss">
// map background
.map-section {
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		padding-bottom: 130vw;
	}
	// form section
	> section:last-child {
		padding-top: 0;
		background-color: transparent;
	}
}

// map background
.map {
	@extend %sizing-absolute-fw-fh;
	background-image: url('@/assets/img/svg/map-pin.svg'), url('@/assets/img/contacts-map.png');
	background-repeat: no-repeat;
	background-position: responsive-size-width-screen(1247) responsive-size-height-screen(343), top right;
	background-size: responsive-size-width-screen(64) auto, 100% auto;
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		background-image: url('@/assets/img/svg/map-pin.svg'), url('@/assets/img/map-pin-mobile.png');
		background-position: left 51% bottom responsive-size-width-mobile(130), center bottom;
		background-size: responsive-size-width-mobile(53) auto, 100% auto;
	}
}

// social links
.sl-wrap {
	@include space-responsive-margin-t(45);
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		margin-top: 29px;
	}
}
</style>
